import axios from '../config/axios';

export async function gestionConsulta(tipo_gestion) {
  return await axios.get(`agendamiento/api/v1/ordenes/gestion/individual/${tipo_gestion}`);
  // const response = await axios.get(`https://959de001.ngrok.io/api/v1/ordenes/gestion/${tipo_gestion}`);
}

export async function actualizarOrden(data) {
  return await axios.post('agendamiento/api/v1/ordenes/actualizar', data);
}

export async function actualizarOrdenResumenLlamada(data) {
  return await axios.put('agendamiento/api/v1/ordenes/gestion/registro_llamada', data);
}

// export async function consultarOrdenes(tipo_consulta, tipo_gestion, dias) {
//   const date = Date.now();
//   return await axios.get(`agendamiento/api/v1/ordenes/gestion/grupal/${tipo_consulta}/${tipo_gestion}/${date - dias}/${date}`);
// }
export async function consultarOrdenesEstadoPorServicio(area, fechaInicial, fechaFinal, estado) {
  return await axios.get(`agendamiento/api/v1/ordenes/gestion/grupal/indicadores/${area}/${fechaInicial}/${fechaFinal}/${estado}`);
}
export async function consultarTiempoOrdenes(area, fechaInicial, fechaFinal, estado) {
  return await axios.get(`agendamiento/api/v1/ordenes/gestion/grupal/tiempos/${area}/${fechaInicial}/${fechaFinal}/${estado}`);
}
export async function consultarOrdenesEstado(area, fechaInicial, fechaFinal, estados) {
  return await axios.post('agendamiento/api/v1/ordenes/gestion/grupal/indicadores', {
    area, fechaInicial, fechaFinal, estados,
  });
}

export async function descargarOrdenes(jsonFacturacion) {
  return await axios.post('agendamiento/api/v1/ordenes/gestion/grupal/resumen', jsonFacturacion);
}

export async function cambiarEstadoGrupoOrdenes(estado, fecha,ordenes , creado_por) {
  return await axios.post('agendamiento/api/v2/ordenes/gestion/grupal/cambiar_estado', { estado, fecha, ordenes, creado_por });
}



// WEBPACK FOOTER //
// ./src/apiService/request/gestionSeguimientos.js